/* istanbul ignore file */

import { helpers } from "vuelidate/lib/validators";

// Validator which ensures a string doesn't contain any special characters (other than dash and period)
const noSpecialCharsExclDash = value => {
	let required = !helpers.req(value);
	let validString = !/[!@#$%^&*()+\=\[\]{};':"\\|,<>\/?]+/.test(value);
	return required || validString;
};

export { noSpecialCharsExclDash };
